import MenuItem from "./MenuItem";

function MenuDaySpecial({ items, imageSrc, heading, language }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="menu-featured">
      <img
        className="menu-featured-image-top"
        src={imageSrc}
        alt="mua-nao-thuc-ay"
      />
      <h3 className="menu-featured-heading">{heading}</h3>
      <div className="menu-featured-list">
        {items.map((item) => (
          <MenuItem
            key={item.code || item.nameVn}
            name={language === "en" ? item.nameEn : item.nameVn}
            price={item.price}
          />
        ))}
      </div>
      <img
        className="menu-featured-image-end"
        src={imageSrc}
        alt="mua-nao-thuc-ay"
      />
    </div>
  );
}

export default MenuDaySpecial;
